import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6.5 17.5L13 24L19.5 17.5L18.793 16.793L13.5 22.086L13.5 0H12.5L12.5 22.086L7.207 16.793L6.5 17.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinBigDown"
);
